module.exports = __webpack_public_path__ + "img/iconProjectPhotograph.2307cb6d.svg";